import CustomStore from "devextreme/data/custom_store";
import useApiConfiguration from "../apiConfig";
import { CommesseApi } from "../data/apis";
import { useMemo } from "react";

export function useSituazioneCommessaDataSource(personaleId: number | null, commessaId: number | null, dataDa: Date | null, dataA: Date | null) {
    const apiConfiguration = useApiConfiguration();

    const dataSource = useMemo(() => {
        const api = new CommesseApi(apiConfiguration);

        return new CustomStore({
            key: "idLavoro",
            loadMode: "raw",
            load: (loadOptions) => {
                return api.getSituazioneCommesse({
                    idPersonale: personaleId,
                    idCommessa: commessaId,
                    dataDa: dataDa,
                    dataA: dataA
                });
            }
        })
    }, [personaleId, commessaId, dataDa, dataA]);

    return dataSource;
}